// Вкладки раздела «Отчёты» и права, которые их открывают.
//
// Отдельный модуль, а не константа внутри ReportsPage: список нужен и сайдбару
// (пункт «Отчёты» виден, пока доступна хотя бы одна вкладка), а импорт из
// страницы затянул бы её в основной бандл и убил ленивую загрузку роута.
//
// Ключи совпадают с key в REPORT_REGISTRY на бэке; `pnpm check:rbac` сверяет
// оба списка в обе стороны, поэтому вкладку нельзя завести мимо реестра прав.

export type TabId =
  | 'dashboard'
  | 'sales'
  | 'cash_flow'
  | 'visits'
  | 'shifts'
  | 'occurrences'
  | 'subscriptions'
  | 'ltv'
  | 'app_usage'
  | 'active_base'
  | 'debts'
  | 'goods';

export interface ReportTab {
  id: TabId;
  label: string;
  /** Есть ли у вкладки фильтр периода (у «Абонементов» — нет). */
  usesPeriod: boolean;
  /** Право из REPORT_REGISTRY, открывающее вкладку. */
  action: string;
}

export const REPORT_TABS: readonly ReportTab[] = [
  { id: 'dashboard', label: 'Дашборд', usesPeriod: true, action: 'reports:dashboard' },
  { id: 'sales', label: 'Продажи', usesPeriod: true, action: 'report:sales' },
  { id: 'cash_flow', label: 'ДДС', usesPeriod: true, action: 'report:cash_flow' },
  { id: 'visits', label: 'История записей', usesPeriod: true, action: 'report:visits' },
  { id: 'shifts', label: 'Смены', usesPeriod: true, action: 'report:shifts' },
  { id: 'occurrences', label: 'Занятия', usesPeriod: true, action: 'report:occurrences' },
  { id: 'subscriptions', label: 'Абонементы', usesPeriod: false, action: 'report:subscriptions' },
  { id: 'ltv', label: 'LTV', usesPeriod: false, action: 'report:ltv' },
  {
    id: 'app_usage',
    label: 'Использование приложения',
    usesPeriod: false,
    action: 'report:app_usage',
  },
  { id: 'active_base', label: 'Активная база', usesPeriod: false, action: 'report:active_base' },
  // Долг не привязан к периоду: показываем всё непогашенное на сейчас.
  { id: 'debts', label: 'Долги', usesPeriod: false, action: 'report:debts' },
  // План 154 Ф4: себестоимость, наценка, напитки и подарки, склад и долг поставщикам.
  { id: 'goods', label: 'Товары', usesPeriod: true, action: 'report:goods' },
];

/** Права всех вкладок — гейт пункта меню «Отчёты» (достаточно любого). */
export const REPORT_TAB_ACTIONS: readonly string[] = REPORT_TABS.map((t) => t.action);
